import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// components

import Navbar from "../components/Navbars/AuthNavbar.js";
import FooterSmall from "../components/Footers/FooterSmall.js";

// views

import Login from "../views/auth/Login.js";
import AdminLogin from "../views/auth/superAdminLogin";
import Register from "../views/auth/Register.js";
import AdminRegister from "../views/auth/superAdminRegister.js";

export default function Auth() {
  return (
    <>
      <Navbar transparent />
      <main>
        <section className="relative w-full h-full py-40 min-h-screen">
          <div
            className="absolute top-0 w-full h-full bg-blueGray-800 bg-no-repeat bg-full"
            style={{
              backgroundImage:
                "url(" + require("../assets/img/register_bg_2.png").default + ")",
            }}
          ></div>
          <Switch>
            <Route path="/auth/super-admin/login" component={AdminLogin} />
            <Route path="/auth/super-admin/register" component={AdminRegister} />
            <Route path="/auth/login" component={Login} />
            <Route path="/auth/register" component={Register}/>
            <Redirect from="/auth" to="/auth/login" />
          </Switch>
          <FooterSmall absolute />
        </section>  
      </main>
    </>
  );
}
